import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=27a73556&scoped=true"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts"
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=27a73556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a73556",
  null
  
)

export default component.exports